<template>
    <div v-bind:class="'product-strate ' + colorClass">
        <div v-for="strate in product_strates" :key="strate.id">
            <div v-for="content in strate.content_strate" :key="content.id">

                <!-- ********* How choose ********** -->
                <div class="strate how-choose" id="choose" v-if="content.__component === 'strates-components.how-choose'">
                  <p v-if="content.title_choose" class="title-strate">{{ content.title_choose }}</p>
                  <div class="table-how-choose" data-scroll="choose">
                      <div class="table-row">
                          <div v-if="content.title_column_one_data" class="title-row" v-html="content.title_column_one_data"></div>
                          <div class="icon-wrapper">
                              <div :id="'img-'+index" :ref="'img-'+index" v-for="(data, index) in content.data_choose" :key="data.id">
                                  <img v-if="data.icon_data" :src="baseURLStrapi+data.icon_data.url" @load="imgIsLoaded" alt="">
                                  <p v-if="data.text_data">{{ data.text_data }}</p>
                              </div>
                          </div>
                      </div>
                      <div class="table-row datas">
                          <div v-if="content.title_column_two_data" class="title-row" v-html="content.title_column_two_data"></div>
                          <div class="number-wrapper">
                              <div :id="'number-img-'+index" v-for="(data, index) in content.data_choose" :key="index">
                                  <div v-if="data.number_data" class="number" v-html="data.number_data"></div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <img class="img-how-choose" v-if="content.how_choose_image" :src="baseURLStrapi+content.how_choose_image.url" alt="">
                </div>

                <!-- ********* Why us ********** -->
                <div class="strate two-columns" id="why_us" v-if="content.__component === 'strates-components.why-us'">
                    <div class="title-wrapper">
                        <img v-if="content.img_why_us" :src="baseURLStrapi+content.img_why_us.url" alt="">
                        <p v-if="content.main_title_why_us">{{ content.main_title_why_us }}</p>
                    </div>
                    <div class="content-wrapper" data-scroll="why_us">
                        <div v-if="content.title_why_us" class="title" v-html="content.title_why_us"></div>
                        <div v-if="content.repeat_why_us" class="icon-wrapper" v-for="why_repeat in content.repeat_why_us" :key="why_repeat.id">
                            <div class="icon">
                                <img v-if="why_repeat.icon_repeat_why_us" :src="baseURLStrapi+why_repeat.icon_repeat_why_us.url" alt="">
                            </div>
                            <div v-if="why_repeat.text_repeat_why_us" class="text" v-html="why_repeat.text_repeat_why_us"></div>
                        </div>
                    </div>
                </div>

                <!-- ********* Delivery ********** -->
                <div class="strate two-columns delivery" id="delivery" v-if="content.__component === 'strates-components.delivery'">
                    <div class="content-wrapper">
                        <div v-if="content.title_delivery" class="title" v-html="content.title_delivery"></div>
                        <div v-if="content.text_delivery" class="text" v-html="content.text_delivery"></div>
                    </div>
                    <div class="title-wrapper" data-scroll="delivery">
                        <img v-if="content.img_delivery" :src="baseURLStrapi+content.img_delivery.url" alt="">
                        <p v-if="content.main_title_delivery">{{ content.main_title_delivery }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import "@/components/Product/ProductStrates/ProductStrates.scss";
    import axios from 'axios'

    export default {
        name: "ProductStrates",

        data() {
            return {
                product_strates: [],
                error: null,
                baseURLStrapi: process.env.VUE_APP_URL_STRAPI
            }
        },

        methods: {
            imgIsLoaded() {
                if( window.innerWidth > 1100 ) {
                    Object.keys(this.$refs).forEach(el => {
                        document.querySelector('#number-'+el).style.width = document.querySelector('#'+el).offsetWidth + "px";
                    })
                }
                else {
                    Object.keys(this.$refs).forEach(el => {
                        document.querySelector('#number-'+el).style.height = document.querySelector('#'+el).offsetHeight + "px";
                    })
                }
            }
        },

        computed: {
          ...mapGetters({ categoryId: "getCategoryId" }),

          colorClass: function () {
              if( this.categoryId == 18 ){ // Chauffe-eau électrique
                  return("blue");
              }
              else if ( this.categoryId == 17 ){ // Chaudière gaz
                  return("pink");
              }
              else if ( this.categoryId == 19 ){ // Radiateur électrique
                  return("yellow");
              }
              else if ( this.categoryId == 29 ){ // Sèche-serviettes
                  return("light-blue");
              }
              else if ( this.categoryId == 43 ){ // Chauffe-eau gaz
                  return("orange");
              }
              else if ( this.categoryId == 87 ){ // Chauffe-eau thermodynamique
                  return("green");
              }
              else if ( this.categoryId == 72 || this.categoryId == 120){ // Pompe à chaleur
                  return("green");
              }
              else if ( this.categoryId == 45 ){ // Bornes électriques
                  return("orange-zeborne");
              }
          }
        },

        async mounted () {
            try {
                const response = await axios.get(this.baseURLStrapi+'/product-strates?category_id='+this.categoryId);
                this.product_strates = response.data;
                if(this.product_strates.length > 0) {
                  this.$root.$emit('stratesProductLoaded', this.product_strates[0].content_strate);
                }
            } catch (error) {
                this.error = error;
            }
        }
    }
</script>
